import { FC } from "react";
import NavDraw from "./NavDraw/NavDraw";
import NavLink from "./NavLink/NavLink";
import { isNavDraw } from "types/CMS/Unum/Navbar/navDraw";
import { navItem } from "types/CMS/Unum/Navbar/navbar";

type navItemProps = {
  item: navItem;
  depth: number;
  maxDepth?: number;
  onClick: (
    e: React.MouseEvent<HTMLElement, MouseEvent>,
    navItem: navItem
  ) => void;
  activeLink?: string;
};

const NavItem: FC<navItemProps> = ({
  item,
  depth,
  onClick,
  activeLink,
  maxDepth = 3,
}) => {
  if (depth === maxDepth) {
    return null;
  }
  if (isNavDraw(item)) {
    return (
      <NavDraw
        draw={{ ...item }}
        depth={depth}
        onClick={onClick}
        activeLink={activeLink}
      />
    );
  } else {
    return (
      <NavLink
        item={{ ...item, depth }}
        onClick={onClick}
        activeLink={activeLink}
      />
    );
  }
};

export default NavItem;